const SOUND_SRC = '/soundfx/button.mp3'

const PRIMARY_CTA_EXACT = ['submit-btn', 'login-btn', 'bulk-print-btn']

const PRIMARY_CTA_PATTERNS = [
  /(^|\s)[\w-]+-btn--primary(\s|$)/,
  /(^|\s)[\w-]+-submit-btn(\s|$)/,
  /(^|\s)[\w-]+-apply-btn(\s|$)/,
]

let audioEl = null

function getAudio() {
  if (!audioEl) {
    audioEl = new Audio(SOUND_SRC)
    audioEl.preload = 'auto'
  }
  return audioEl
}

function classString(el) {
  if (!el || !el.className) return ''
  if (typeof el.className === 'string') return el.className
  if (typeof el.className.baseVal === 'string') return el.className.baseVal
  return ''
}

function isPrimaryCta(el) {
  if (!el) return false
  const optIn = el.getAttribute && el.getAttribute('data-cta-sound')
  if (optIn === 'off') return false
  if (optIn === 'on') return true
  const list = el.classList
  if (list && PRIMARY_CTA_EXACT.some((c) => list.contains(c))) return true
  const cls = classString(el)
  return PRIMARY_CTA_PATTERNS.some((re) => re.test(cls))
}

function playSound() {
  try {
    const audio = getAudio()
    audio.currentTime = 0
    const p = audio.play()
    if (p && typeof p.catch === 'function') p.catch(() => {})
  } catch (e) {
    // autoplay policy or unsupported — silent fail is fine
  }
}

function handleClick(event) {
  const start = event.target
  if (!start || !start.closest) return
  const el = start.closest('button, a, [role="button"], [data-cta-sound]')
  if (!el) return
  if (el.disabled) return
  if (el.getAttribute('aria-disabled') === 'true') return
  if (!isPrimaryCta(el)) return
  playSound()
}

export const ButtonSoundPlugin = {
  install() {
    if (typeof document === 'undefined') return
    document.addEventListener('click', handleClick, true)
  },
}
